export default from './floating-create-button';



// WEBPACK FOOTER //
// ./app/components/floating-create-button/index.js